module.exports = __webpack_public_path__ + "img/edit_square.f89bdab9.svg";